module.exports = __webpack_public_path__ + "img/icon-youyou-gif.00e19158.gif";